export default __webpack_public_path__ + "static/media/referral__icon-4.3d6e474b.svg";